module["exports"] = [
  "Sig.",
  "Dott.",
  "Dr.",
  "Ing."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/name/prefix.js
// module id = 1579
// module chunks = 0